import { render, staticRenderFns } from "./edc-submitted-unscheduled-packets-reskin.vue?vue&type=template&id=0c19e001&scoped=true&"
import script from "./edc-submitted-unscheduled-packets-reskin.vue?vue&type=script&lang=js&"
export * from "./edc-submitted-unscheduled-packets-reskin.vue?vue&type=script&lang=js&"
import style0 from "./edc-submitted-unscheduled-packets-reskin.vue?vue&type=style&index=0&id=0c19e001&scoped=true&lang=scss&"
import style1 from "./edc-submitted-unscheduled-packets-reskin.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c19e001",
  null
  
)

component.options.__file = "edc-submitted-unscheduled-packets-reskin.vue"
export default component.exports